import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from "@/store";

var firebase = require("firebase/app");
require("firebase/auth");

Vue.use(VueRouter)

	const beforeEnter = (to, from, next) => {
		if (store.state.authModule.logged) {
			next({ path: "/admin" });
		} else {
			next();
		}
	};

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/i/:id',
		name: 'Index',
		component: () => import(/* webpackChunkName: "index" */ '../views/Index.vue')
	},
  {
    path: '/i/:id/es',
		name: 'CartES',
		component: () => import(/* webpackChunkName: "index" */ '../views/es/Index.vue')
	},
	{
		path: '/i/:id/es/carta/:cat',
		name: 'CartListEs',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/es/CartList.vue')
	},	
	{
		path: '/i/:id/es/about',
		name: 'AboutEs',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/es/About.vue')
	},
	{
		path: '/i/:id/es/share',
		name: 'ShareEs',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/es/Share.vue')
	},
	{
		path: '/i/:id/es/splash',
		name: 'SplashEs',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/es/Splash.vue')
	},	
  {
    path: '/i/:id/en',
		name: 'CartEN',
		component: () => import(/* webpackChunkName: "index" */ '../views/en/Index.vue')
	},
	{
		path: '/i/:id/en/cart/:cat',
		name: 'CartListEn',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/en/CartList.vue')
	},	
	{
		path: '/i/:id/en/about',
		name: 'AboutEn',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/en/About.vue')
	},
	{
		path: '/i/:id/en/share',
		name: 'ShareEn',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/en/Share.vue')
	},
	{
		path: '/i/:id/en/splash',
		name: 'SplashEn',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/en/Splash.vue')
	},			
  {
    path: '/i/:id/de',
		name: 'CartDE',
		component: () => import(/* webpackChunkName: "index" */ '../views/de/Index.vue')
	},
	{
		path: '/i/:id/de/cart/:cat',
		name: 'CartListDe',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/de/CartList.vue')
	},	
	{
		path: '/i/:id/de/about',
		name: 'AboutDe',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/de/About.vue')
	},
	{
		path: '/i/:id/de/share',
		name: 'ShareDe',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/de/Share.vue')
	},	
	{
		path: '/i/:id/de/splash',
		name: 'SplashDe',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/de/Splash.vue')
	},	

  {
    path: '/i/:id/fr',
		name: 'CartFR',
		component: () => import(/* webpackChunkName: "index" */ '../views/fr/Index.vue')
	},
	{
		path: '/i/:id/fr/cart/:cat',
		name: 'CartListFr',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/fr/CartList.vue')
	},	
	{
		path: '/i/:id/fr/about',
		name: 'AboutFr',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/fr/About.vue')
	},
	{
		path: '/i/:id/fr/share',
		name: 'ShareFr',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/fr/Share.vue')
	},
	{
		path: '/i/:id/fr/splash',
		name: 'SplashFr',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/fr/Splash.vue')
	},				
  {
    path: '/404',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue')
	},

	{
		path: '/login',
		name: 'Login',
		component: () => import(/* webpackChunkName: "Login" */ '../views/admin/Login.vue'),
		beforeEnter: (to, from, next) => beforeEnter(to, from, next),
	},
		{
			path: "/admin",
			name: "AdminDashboard",
			component: () =>
				import(
						/* webpackChunkName: "dashboard" */ "../views/admin/Dashboard.vue"
				),
			meta: { requiresAuth: true, title: "Escritorio Administrativo" },
			children: [

				{
					path: "clientes",
					name: "AdminCustomer",
					component: () =>
						import(
								/* webpackChunkName: "customer" */ "@/views/admin/Customer.vue"
						),
					meta: { role: "admin", title: "Clientes" },
				},
				{
					path: "negocios",
					name: "AdminBusiness",
					component: () =>
						import(
								/* webpackChunkName: "business" */ "@/views/admin/Business.vue"
						),
					meta: { role: "admin", title: "Negocios" },
				},
				{
					path: ":business_id/:business_name/categories",
					name: "AdminCategories",
					component: () =>
						import(
								/* webpackChunkName: "categories" */ "@/views/admin/Categories.vue"
						),
					meta: { role: "admin", title: "Negocios" },
				},
				{
					path: ":business_id/:business_name/:category_id/:category_name/:category_subtitle?/items",
					name: "AdminItems",
					component: () =>
						import(
								/* webpackChunkName: "items" */ "@/views/admin/Items.vue"
						),
					meta: { role: "admin", title: "Items" },
				},
				
			]
		},
	


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
	const lockedRoute = to.matched.some((record) => record.meta.requiresAuth);
	const user = firebase.auth().currentUser;
	if (lockedRoute === true && user === null) {
		next({ name: "Home" });
	} else {
		next();
	}
});

export default router
